import {useState} from 'react'
import {useTranslation} from 'react-i18next'
import {PaginatedDataTable} from '@/components/cartera/paginated-data-table'
import {AnularFacturaDialog, PagoManualDialog} from '@/components/cartera/factura-action-dialogs'
import {useFacturaColumns} from '@/components/cartera/factura-columns'
import {useTableState} from '@/hooks/common/use-table-state'
import {useCarteraFacturas, type AdminInvoice, type BillingInvoiceEstado} from '@/hooks/inci/cartera/use-cartera'

const ESTADOS: BillingInvoiceEstado[] = ['emitida', 'pagada', 'vencida', 'anulada']

export function FacturasSection({partnerId}: {partnerId: string}) {
  const {t} = useTranslation()
  const table = useTableState('created_at')
  const [estado, setEstado] = useState<BillingInvoiceEstado | ''>('')
  const {data, isLoading} = useCarteraFacturas({
    page: table.page,
    search: table.search,
    estado,
    payerKind: '',
    partnerId,
  })
  const [anularTarget, setAnularTarget] = useState<AdminInvoice | null>(null)
  const [pagoManualTarget, setPagoManualTarget] = useState<AdminInvoice | null>(null)
  const columns = useFacturaColumns(setAnularTarget, setPagoManualTarget, 'partner-detail-factura')

  return (
    <div data-testid="partner-detail-facturas">
      <PaginatedDataTable
        title={t('cartera.tabs.facturas')}
        columns={columns}
        data={data}
        isLoading={isLoading}
        page={table.page}
        onPageChange={table.setPage}
        emptyMessage={t('cartera.facturas.empty')}
        toolbar={
          <select
            value={estado}
            onChange={(e) => {
              setEstado(e.target.value as BillingInvoiceEstado | '')
              table.setPage(1)
            }}
            aria-label={t('cartera.facturas.filtroEstado')}
            data-testid="partner-detail-facturas-filtro-estado"
            className="h-9 rounded-md border border-input bg-transparent px-2 text-sm text-foreground">
            <option value="">{t('cartera.filtroTodos')}</option>
            {ESTADOS.map((e) => (
              <option key={e} value={e}>
                {t(`cartera.estado.${e}`)}
              </option>
            ))}
          </select>
        }
      />

      <AnularFacturaDialog target={anularTarget} onClose={() => setAnularTarget(null)} testPrefix="partner-detail" />
      <PagoManualDialog
        target={pagoManualTarget}
        onClose={() => setPagoManualTarget(null)}
        testPrefix="partner-detail"
      />
    </div>
  )
}
